import React from 'react';

function HeaderTitle({ text }) {
  return <h2 style={{ fontSize: 20 }}>{text}</h2>;
}

export default HeaderTitle;
